import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-page">
      <SEO 
        title="Política de Privacidade"
        description="Política de Privacidade da AASPS. Saiba como protegemos os seus dados pessoais e quais os seus direitos."
        url="/politica-privacidade"
      />
      <Header />
      
      {/* Hero Section */}
      <div className="privacy-hero">
        <div className="privacy-hero-content">
          <h1>Política de Privacidade</h1>
        </div>
      </div>
      
      <main className="privacy-content">
        <div className="privacy-container">
          
          <p>
            A privacidade e a proteção dos seus dados pessoais são uma prioridade permanente da AASPS - Associação de Apoio e Segurança Psico Social, pelo que assumimos o compromisso firme de zelar pela segurança, confidencialidade e utilização adequada desses dados.
          </p>
          
          <p>
            A AASPS apenas recolhe os dados estritamente necessários ao desenvolvimento da sua atividade. Estes dados não serão utilizados para quaisquer finalidades que não as expressamente indicadas.
          </p>
          
          <p>
            Os dados recolhidos serão conservados apenas pelo período necessário às finalidades que motivaram a sua recolha, salvo quando exista obrigação legal específica ou interesse legítimo da AASPS na sua manutenção, exceto nos casos em que prevaleçam direitos ou liberdades fundamentais do titular dos dados.
          </p>
          
          <p>
            No âmbito da sua atividade, a AASPS poderá ceder dados pessoais a entidades terceiras. Nesses casos, a AASPS assegurará previamente que tais entidades oferecem garantias adequadas de implementação de medidas técnicas e organizativas que garantam a conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD).
          </p>

          <h2>Que tipos de dados pessoais são recolhidos</h2>
          <p>
            A AASPS recolhe apenas os dados pessoais necessários para instruir e manter atualizados os processos individuais dos seus Associados.
          </p>

          <h2>Para que finalidades são recolhidos esses dados pessoais</h2>
          <p>A recolha e tratamento da informação têm por finalidade:</p>
          <ul>
            <li>Manter, administrar e gerir a relação existente entre o Associado e a AASPS.</li>
            <li>Informar o Associado sobre serviços, atividades, iniciativas e valências que possam ser do seu interesse.</li>
            <li>Recolher sugestões e contributos dos Associados.</li>
            <li>Produzir estatísticas sociais e de saúde para apresentação às entidades tutelares, nomeadamente Ministério da Saúde e Ministério do Trabalho, Solidariedade e Segurança Social.</li>
            <li>Apresentar candidaturas a projetos com vista à obtenção de financiamentos, donativos ou subsídios.</li>
          </ul>

          <h2>Quem tem acesso aos seus dados pessoais</h2>
          <p>
            A AASPS adotou medidas adequadas para garantir que apenas os seus funcionários ou colaboradores devidamente autorizados, e no estrito âmbito das suas funções, têm acesso aos seus dados pessoais, assegurando sempre o cumprimento desta Política de Privacidade e das obrigações legais em matéria de proteção de dados.
          </p>
          <p>
            Sempre que a AASPS transmita dados pessoais de cujo tratamento é responsável a terceiros, garantirá contratualmente que esses terceiros cumprem o RGPD e toda a legislação aplicável, assegurando a proteção e segurança dos dados pessoais.
          </p>

          <h2>Aceder, alterar e apagar dados pessoais</h2>
          <p>Os titulares dos dados podem exercer os seus direitos de:</p>
          <ul>
            <li>Acesso</li>
            <li>Retificação</li>
            <li>Portabilidade</li>
            <li>Apagamento</li>
            <li>Limitação do tratamento</li>
          </ul>
          <p>
            Os pedidos devem ser enviados para o e-mail: <a href="mailto:geral@aasps.pt">geral@aasps.pt</a>
          </p>
          <p>Os pedidos serão respondidos no prazo máximo de 30 dias.</p>

          <h2>Segurança dos dados pessoais</h2>
          <p>
            A AASPS compromete-se a cumprir a obrigação de sigilo relativamente aos dados pessoais que recolhe e adotará todas as medidas necessárias para impedir a sua alteração, perda, tratamento ou acesso não autorizado, em conformidade com a legislação vigente.
          </p>

          <h2>Uso de Cookies</h2>
          <p>O website AASPS.PT utiliza cookies próprios e de terceiros para:</p>
          <ul>
            <li>Analisar padrões de utilização</li>
            <li>Melhorar os serviços disponibilizados</li>
            <li>Proporcionar uma navegação adequada e eficiente</li>
          </ul>
          <p>
            Os cookies utilizados não armazenam informação pessoal identificável. Ao navegar no nosso website, está a consentir a utilização destes cookies, salvo se configurar o seu navegador para os bloquear.
          </p>

          <h2>Modificações à Política de Privacidade</h2>
          <p>
            A AASPS pode alterar a presente Política de Privacidade sempre que necessário, de acordo com a legislação aplicável. Quaisquer alterações serão devidamente publicitadas, de forma a garantir que o titular dos dados se encontra informado. Sempre que legalmente exigível, será solicitado novo consentimento.
          </p>

          <h2>Contactos</h2>
          <p>
            Para qualquer questão relacionada com esta Política de Privacidade ou para apresentar sugestões, poderá contactar:
          </p>
          <address>
            <strong>AASPS — Associação de Apoio e Segurança Psico Social</strong><br />
            Rua do Cruzeiro, 194 B<br />
            1300-172 Lisboa<br />
            Tel: <a href="tel:+351213630884">+351 213 630 884</a><br />
            E-mail: <a href="mailto:geral@aasps.pt">geral@aasps.pt</a>
          </address>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
